import React from 'react';
import LogoBlack from './LogoBlack';
import Nav from './Nav';
import MobileMenu from './MobileMenu';
import LogoBox from './LogoBox';
import OffCanvasStyleOne from './OffCanvasStyleOne';
import { contactService } from '../../services/contactService';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: null,
            stickyMenu: typeof window !== 'undefined' && window.scrollY > 130
        };
    }

    handleScroll = () => {
        const stickyMenu = window.scrollY > 130;
        if (stickyMenu !== this.state.stickyMenu) {
            this.setState({ stickyMenu });
        }
    };

    async componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        try {
            const res = await contactService.getContactSettings();
            if (res.success && res.data) {
                this.setState({ settings: res.data });
            }
        } catch (err) {
            // Keep defaults
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render(){
        const { settings } = this.state;
        const phone = settings?.phone || ''; 
        const email = settings?.email || ''; 

        return (
            <>
                <header className="main-header main-header-three clearfix">
                    <div className="main-header-three__wrapper">

                        <div className="main-header-three__middle">
                            <div className="container">
                                <div className="main-header-three__middle-inner">
                                    <LogoBox />

                                    <div className="contact-info">
                                        <ul>
                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-pin"></span>
                                                </div>
                                                <div className="text-box">
                                                    <h3 className='text-dark'>Our Location</h3>
                                                    <p>Namakkal, Tamil Nadu</p>
                                                </div>
                                            </li>

                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-email"></span>
                                                </div>
                                                <div className="text-box">
                                                    <h3 className='text-dark'>Online Support</h3>
                                                    <p className="email"><a href={`mailto:${email}`}>{email}</a></p>
                                                </div>
                                            </li>

                                            <li>
                                                <div className="icon-box">
                                                    <span className="icon-phone-call"></span>
                                                </div>
                                                <div className="text-box">
                                                    <h3 className='text-dark'>Free Contact</h3>
                                                    <p className="number"><a href={`tel:${phone}`}>{phone}</a></p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="main-header-three__bottom ">
                            <div className="container">
                                <div className="main-header-three__bottom-inner">
                                    <div className="main-header-one__bottom-left">
                                        <nav className="main-menu main-menu--1">
                                            <div className="main-menu__inner">
                                                <MobileMenu />
                                                <div className="stricky-one-logo">
                                                    <LogoBlack />
                                                </div>
                                                <Nav />
                                            </div>
                                        </nav>
                                    </div>

                                    <div className="main-header-one__bottom-right">
                                        <div className="side-content-button-box">
                                            <OffCanvasStyleOne />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </header>

                <div className={`stricky-header stricked-menu main-menu sticky-blue-navbar${this.state.stickyMenu ? ' stricky-fixed' : ''}`}>
                    <div className="main-menu__inner">
                        <Nav />
                    </div>
                </div>

            </>
        )
    }
}
